import { Component, Input } from '@angular/core';
import { ContainerJobContact } from '../../../Container/model/ContainerJobContact';
import { JobAddressSelection } from '../../../Container/model/JobAddressSelection';
import { ContainerMovementListItem } from '../../../Container/model/ContainerMovementListItem';

@Component({
  selector: 'app-container-job-from-location-details',
  standalone: true,
  imports: [],
  templateUrl: './container-job-from-location-details.component.html',
  styleUrl: './container-job-from-location-details.component.scss'
})
export class ContainerJobFromLocationDetailsComponent {
  @Input()
  currentLegData?: ContainerMovementListItem;

  @Input()
  fromJobContact?: ContainerJobContact | null;
}
